export default __webpack_public_path__ + "static/media/img1.8c69aeff.jpg";